module.exports = __webpack_public_path__ + "static/media/placeholder-org.d95058b4.png";